import styled from 'styled-components'
import colors from 'constants/colors'

export const AlertBoxContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 54px;
  box-sizing: border-box;
  border-collapse: collapse;
  width: 285px;  
  display: ${(props) => (props.active ? 'inline-block': 'none')};
  z-index: 1000;
`;

export const AlertItem = styled.div`
  display: flex;
  width: 100%;
  height: 84px;
  background-color: ${colors.black1};
  border: solid ${colors.black2};
  border-width: 1px;
  cursor: pointer;

  .link {
    width: 36px;
    display: flex;
    align-items:center;
    justify-content: center;
    background-color: ${colors.black5};
    cursor: pointer;
  }
  
  .alertBody {
    font-size: 12px;
    padding: 13px 5px;
    width: 100%;
    min-width: 187px;
    position: relative;

    .alertTitle {
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .alertType {
        color: ${(props) => props.color};
        font-weight: 600;
        margin: 0 10px;
        ${(props) => props.isRead? `color: ${colors.grey};`: null}
      }
      .roomNumber {

        font-weight: 600;
        color: ${colors.yellow};
      }
    }
    
    .content {
      margin-left: 10px;
      height: 35px;
      justify-content: center;

      .alertInfo {
        font-weight: 600;
        color: ${colors.grey};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        ${(props) => props.isRead? `color: ${colors.grey};`: null}

        .originator {
          margin-right: 10px;
        }

        .dateTime {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: ${colors.grey};
          ${(props) => props.isRead? `color: ${colors.grey};`: null}

          /* & > span:last-child {
            position: relative;
            top: 1px;
            color: ${colors.red};
            ${(props) => props.isRead? `color: ${colors.grey};`: null}
          } */
        }
      }

      .description {
        font-weight: 600;
        color: ${colors.white};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        ${(props) => props.isRead? `color: ${colors.grey};`: null}
      }
    }
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    ${({ mobile }) => (mobile? `
      height: 110px;
      .alertBody {
        font-size: 15px;
        line-height: 2;
      }
    `: null
    )};
  }

  @media only screen and (max-width: 767px) {
    ${({ mobile }) => (mobile? `
      height: 89px;
      .alertBody {
        font-size: 13px;
      }
    `: null
    )};
  }


`;